import React, {useEffect, useRef, useState} from 'react';
import {isUpdate, requiredChecker} from "../commonmethod/CommonMethod";
import {valid, validator} from "../commonmethod/ValidationChecker";
import {isEmpty} from "lodash";


/*
* Todo api로딩이 안된건지 값 자체가 없는건지 구분해서 skeleton 을 보여줘야 한다.
* */
function ITER_SimmsInput({onChange, onKeyDown, data, update, style, constraint, auth, clicked, setClicked, placeHolder}) {
    const [value, setValue] = useState(data||'');
    const [localClicked, setLocalClicked] = useState(false);
    const hasParentClickState = typeof setClicked === "function";
    const isClicked = hasParentClickState ? !!clicked : localClicked;
    const setClickState = hasParentClickState ? setClicked : setLocalClicked;

    useEffect(() => {
        setValue(data ?? "");
    }, [data]);

    const {updatedStyle, isRequiredError} = validator(constraint, value, style);
    const inputRef = useRef(null);
    const handleSpanClick = () => {
        setClickState(true);
        setTimeout(() => {
            inputRef.current?.focus();
        }, 0);
    };

    const handleChange = (e) => {
        setValue(e.target.value)
        if(!update){
            onChange(e.target.value);
        }
    }

    const handleKeyDown = (e) => {
        // esc키 > 기존값 복원
        if (e.key === "Escape") {
            setValue(data);
            setClickState(false);
            return;
        }

        // enter 시 blur처리
        if (e.key === "Enter") {
            inputRef.current?.blur();
        }
    }

    // blur시 update
    const handleBlur = (e) => {
        // 공백비교
        if(isEmpty(data) && isEmpty(value)) {
            setClickState(false);
            return;
        }

        // 데이터비교
        if(data === value){
            setClickState(false);
            return;
        }

        // 수정페이지에서만 사용
        // eslint-disable-next-line no-restricted-globals
        if(confirm("수정하시겠습니까?")) {
            if (update) onKeyDown(value, e);
        }else{
            setValue(data ?? "");
        }

        setClickState(false);
    }

    const fieldEditable = !update || !!auth;
    const showInput = !update || (!!auth && isClicked);

    return (
        <>
            {showInput ?
                <input
                    ref={inputRef}
                    type={"text"}
                    className={`basic-input ${!update ? 'input-style' :''}`}
                    style={updatedStyle}
                    onBlur={handleBlur}
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    maxLength={255}
                />
                :
                <span
                    className={fieldEditable ? "edit-input" : "asset-detail-kv-value"}
                    onClick={fieldEditable ? handleSpanClick : undefined}
                >
                    {data ?? placeHolder }
                </span>
            }
        </>
    );
}

export default ITER_SimmsInput;